const API_BASEURL = 'https://jasmine-api.misteraladin.com/activities';
const API_KEY = 'H7cuh2C7Ym8RJr1VgvcP4822jypnML';
const API_GATEWAY = 'https://jasmine-api.misteraladin.com/payment-gateways/';
const WEB_URL = 'https://www.misteraladin.com/aladinxplore';
const X_API_KEY = 'LNm#t*WSRB6#dPDTo~m8';
const X_SECRET_KEY = 'Fl!ZSQRH$uAU(fq%-Np9##ClEAAeYaxIqt&zy%ecE~UTa$xvP0';
const EXTRANET_WEB_URL = 'https://production-partner-explore.misterb2b.com';
const EXTRANET_API_URL = 'https://production-api-partner-explore.misteraladin.com/api/v1';
const EXTRANET_APP_ID = '100016';
const EXTRANET_APP_SECRET = 'f3a89165a9661683b2748b6ec80ee155';

const X_API_KEY_V2 = 'ZcrvZBN8VdYtK435J37j';
const API_BASEURL_V2 = 'https://pg-api.misteraladin.com/payment-gateways/v2';
const X_SECRET_KEY_V2 = 'ZbY7scgYJX7zf3aQWh9FBpUwqMUKUJQzrHK';

export { 
	API_KEY, 
    API_GATEWAY, 
    WEB_URL, 
    X_API_KEY, 
    X_SECRET_KEY, 
    EXTRANET_WEB_URL, 
    EXTRANET_API_URL, 
    EXTRANET_APP_ID, 
    EXTRANET_APP_SECRET,
    API_BASEURL_V2,
    X_API_KEY_V2,
    X_SECRET_KEY_V2,
};

export default API_BASEURL;



// WEBPACK FOOTER //
// ./src/config.js